// generated by frontend/scripts/generate-build-info.mjs — do not edit
export const BUILD_SHA = '8b9c60e';
